import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlay, faXmark, faArrowRight, faFire, 
} from '@fortawesome/free-solid-svg-icons';
import { workVisas } from '../data/workVisas';

/* ---- EDIT: only 2 videos. Put the YouTube video ID here ---- */
const videos = [
    {
        id: 1,
        title: 'Visa Detail (English)',
        src: `assets/english.mp4`,
        // optional thumbnail image in public/assets, or leave as '' to use the video's first frame
        poster: '',
    },
    {
        id: 2,
        title: 'Visa Detail (Urdu/Hindi)',
        src: `assets/urdu-hindi.mp4`,
        poster: '',
    },
];

/* ---- EDIT: posters (image is taken from the country slug) ---- */
const posters = [
    { slug: 'portugal', title: 'Work in Portugal', subtitle: 'Applications open' },
    { slug: 'spain', title: 'Work in Spain', subtitle: 'Limited slots' },
    { slug: 'france', title: 'Work in France', subtitle: 'Talent Passport & more' },
    { slug: 'belgium', title: 'Work in Belgium', subtitle: 'Talent Passport & more' },
    { slug: 'greece', title: 'Work in Greece', subtitle: 'Talent Passport & more' },
    { slug: 'bulgaria', title: 'Work in Bulgaria', subtitle: 'Talent Passport & more' },
];

const PopularVisas = () => {
    const [activeVideo, setActiveVideo] = useState(null);

    useEffect(() => {
        if (!activeVideo) return;
        const onKey = (e) => e.key === 'Escape' && setActiveVideo(null);
        document.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = '';
        };
    }, [activeVideo]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
            {/* Header */}
            <section className="pt-24 pb-16 bg-gradient-to-r from-blue-600 to-cyan-600 text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-sm font-medium mb-6">
                        <FontAwesomeIcon icon={faFire} className="mr-2 text-orange-300" />
                        LATEST WORK VISAS
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">Popular Work Visas in Europe</h1>
                    <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
                        France, Belgium, Greece, Bulgaria, Spain and Portugal – the work visa routes
                        people ask us about the most right now.
                    </p>
                </div>
            </section>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-20">
                {/* Posters */}
                <section>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Latest Offers</h2>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {posters.map((p) => {
                            const c = workVisas.find((v) => v.slug === p.slug);
                            if (!c) return null;
                            return (
                                <Link to={`/popular-visas/${c.slug}`} key={p.slug}>
                                    <div className="relative h-96 rounded-2xl overflow-hidden shadow-lg bg-blue-900 group">
                                        <img
                                            src={c.image}
                                            alt={p.title}
                                            className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition duration-500"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                                        <div className="absolute top-4 left-4 bg-white/90 rounded-full px-3 py-1 text-2xl">{c.flag}</div>
                                        <div className="absolute bottom-0 p-6 text-white">
                                            <span className="inline-block bg-orange-500 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                                                {p.subtitle}
                                            </span>
                                            <h3 className="text-3xl font-bold mb-3">{p.title}</h3>
                                            <span className="inline-flex items-center text-sm font-semibold bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
                                                View Details <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </section>

                {/* Videos (2) */}
                {/* Videos (2) */}
                <section>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Watch &amp; Learn</h2>
                    <div className="grid md:grid-cols-2 gap-8">
                        {videos.map((v) => (
                            <button
                                key={v.id}
                                onClick={() => setActiveVideo(v)}
                                className="group text-left bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300"
                            >
                                <div className="relative aspect-video bg-gray-900">
                                    {/* Thumbnail: poster image if given, otherwise first frame of the video */}
                                    <video
                                        src={`${v.src}#t=0.5`}
                                        poster={v.poster || undefined}
                                        preload="metadata"
                                        muted
                                        playsInline
                                        className="w-full h-full object-cover pointer-events-none"
                                    />
                                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition flex items-center justify-center">
                                        <span className="w-16 h-16 rounded-full bg-white/90 text-blue-600 flex items-center justify-center text-xl shadow-lg group-hover:scale-110 transition">
                                            <FontAwesomeIcon icon={faPlay} className="ml-1" />
                                        </span>
                                    </div>
                                </div>
                                <div className="p-5">
                                    <h3 className="font-semibold text-gray-900">{v.title}</h3>
                                </div>
                            </button>
                        ))}
                    </div>
                </section>
              
                {/* CTA */}
                <section className="text-center">
                    <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 max-w-2xl mx-auto">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Not sure which country is right for you?</h2>
                        <p className="text-gray-600 mb-6">
                            Talk to our experts and get a recommendation based on your profile.
                        </p>
                        <Link to="/contact">
                            <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transition duration-300">
                                Book Consultation
                            </button>
                        </Link>
                    </div>
                </section>
            </div>

            {/* Video modal */}
            {/* Video modal */}
            {activeVideo && (
                <div
                    className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4"
                    onClick={() => setActiveVideo(null)}
                >
                    <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
                        <button
                            onClick={() => setActiveVideo(null)}
                            className="absolute -top-12 right-0 text-white text-2xl hover:text-blue-300"
                            aria-label="Close video"
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                        <div className="aspect-video rounded-xl overflow-hidden bg-black">
                            <video
                                key={activeVideo.id}
                                src={activeVideo.src}
                                poster={activeVideo.poster || undefined}
                                controls
                                autoPlay
                                playsInline
                                className="w-full h-full"
                            />
                        </div>
                        <p className="text-white mt-3 font-medium">{activeVideo.title}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PopularVisas;
